import { ManageDeviceService } from './../../../device-management/device-registration/manage-device.service';
import { forkJoin } from 'rxjs';
import { Component, ComponentRef, ContentChildren, EventEmitter, OnInit, Output, QueryList, ViewChild } from "@angular/core";
import { TabComponent } from "../tab/tab.component";
import { TabDirective } from '../tab.directive';
import { TabService } from 'src/app/services/tab-close.service';
import { DataPersistenceService } from 'src/app/utilities/data-persistence/data-persistence.service';
import { NestedGridService } from 'src/app/device-management/nested-grid-renderer/nested-grid.service';

@Component({
  selector: 'tab-container',
  templateUrl: './tab-container.component.html',
  styleUrls: ['./tab-container.component.scss']
})
export class TabContainerComponent implements OnInit {
  dynamicTabs: TabComponent[] = [];
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  isDashboardActive: Boolean = true;
  @ViewChild(TabDirective)
  dynamicTabPlaceholder!: TabDirective;
  @Output() tabLengthExceeded = new EventEmitter();
  private readonly maxTabCount=7;
  constructor(private manageDeviceService: ManageDeviceService, private tabService: TabService, private dataPersistenceService: DataPersistenceService,private nestedGridService:NestedGridService) { }


  ngOnInit(): void {
    this.tabService.tabUnsavedDataEvent$.subscribe(data => {
      if(data.deviceLifeCycleState){
        this.attachAsteriskToUnsavedTabs(data)
      }
      else{
        const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          let index = this.dynamicTabs?.findIndex(x => x.dataContext.deviceId === data.data.deviceId);
          const componentRef = viewContainerRef.get(this.dynamicTabs?.findIndex(x => x.dataContext.deviceId === data.data.deviceId));
          const context = (componentRef as any)?.rootNodes[0].getElementsByClassName('tabChildComponent')[0].children[0].__ngContext__;
          if (context === data.context) {
            if (data.isFormDirty) {
              //apply asterisk
              if(!this.dynamicTabs[index].title.includes("*")){
                this.dynamicTabs[index].title += " *";
              } 
            }
            else {
              //remove asterisk
              this.dynamicTabs[index].title = this.dynamicTabs[index].title.replace("*", "").trimEnd();
            }
          }
        }           
    });
    this.tabService.tabCloseEvent$.subscribe(data=>{
      if(data){
        this.closeActiveTab();
      }
    })
    this.tabService.tabTitleChangedEvent$.subscribe(data=>{
      const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
          let index = this.dynamicTabs?.findIndex(x => x.dataContext.deviceId === data.deviceId);
          const componentRef = viewContainerRef.get(this.dynamicTabs?.findIndex(x => x.dataContext.deviceId === data.deviceId));
          const context = (componentRef as any)?.rootNodes[0].getElementsByClassName('tabChildComponent')[0].children[0].__ngContext__;
          if (context === data.context) {            
                this.dynamicTabs[index].title = data.title;  
                if(data.tooltip)  {
                  this.dynamicTabs[index].tooltip = data.tooltip; 
                }                    
          }        
    })
    forkJoin([this.manageDeviceService.getCountryData(), this.manageDeviceService.getProductTypes()]).subscribe(results => {
      this.manageDeviceService.countryDataStatic = results[0].data;
      this.manageDeviceService.productTypesStatic = results[1].data.sort((x, y) => {
        if (x.description < y.description) {
          return -1;
        }
        if (x.description > y.description) {
          return 1;
        }
        return 0;
      });
    });
  }

  attachAsteriskToUnsavedTabs(data) {
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
    let componentRefs: any = [];
    let contexts: any = [];
    this.dynamicTabs.forEach((element, index) => {
      componentRefs.push({ viewContainer: viewContainerRef.get(index), indexOfTab: index })
    });
    componentRefs.forEach(component => {
      contexts.push({ componentItemContext: (component.viewContainer as any)?.rootNodes[0].getElementsByClassName('tabChildComponent')[0].children[0].__ngContext__, indexOfTab: component.indexOfTab })
    });
    contexts.forEach(context => {
      if (context.componentItemContext === data.context) {
        if (data.isFormDirty) {
          if(!this.dynamicTabs[context.indexOfTab].title.includes("*")){
            this.dynamicTabs[context.indexOfTab].title += " *";
          }          
        }
        else {
          this.dynamicTabs[context.indexOfTab].title = this.dynamicTabs[context.indexOfTab].title.substring(0, this.dynamicTabs[context.indexOfTab].title.length - 2);
        }
      }
    })
  }
  ngAfterContentInit() {
    const activeTabs = this.tabs.filter(tab => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  openTab(title: string, template: any, data: any, isCloseable = false, tooltip = null,isExternalAsset = false) {

    //check if tab is already open, if yes, just make that tab active
    let result = this.IsTabExist(data, title);

    if (this.dynamicTabs.length >= this.maxTabCount && result.tabExist == false) {
      this.tabLengthExceeded.emit();
    }
    else {
      if (result.tabExist) {
        this.selectTab(this.dynamicTabs[result.indexMatch]);
      }
      else {
        const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        let componentRef: ComponentRef<Component>;
        componentRef = viewContainerRef.createComponent(TabComponent);
        const instance: TabComponent = componentRef.instance as TabComponent;
        instance.title = title;
        instance.template = template;
        instance.dataContext = data;
        if(isExternalAsset)
        {
          instance.tooltip = tooltip ?? (data.SerialNumber ?  `${data.ProductType} - ${data.SerialNumber}` : title);
        }
        else
        instance.tooltip = tooltip ?? (data.serialNumber ? (data.displayName ? `${data.displayName} - ${data.serialNumber}`
          : `${data.product} - ${data.serialNumber}`) : title);
        instance.isCloseable = isCloseable;
        instance.hasApiError = false;
        instance.isExternalAsset = isExternalAsset
        this.dynamicTabs.push(componentRef.instance as TabComponent);
        this.dataPersistenceService.updateTabInserted(this.dynamicTabs);
        this.selectTab(this.dynamicTabs[this.dynamicTabs.length - 1]);
      }
    }
  }

  selectTab(tab: TabComponent) {
    this.tabs.toArray().forEach(t => (t.active = false));
    this.dynamicTabs.forEach(t => (t.active = false));
    tab.active = true;
    this.isDashboardActive = this.tabs.first.active;
    this.nestedGridService.notifyRecalculateGrid();
  }

  handleTabClose(tab: TabComponent) {
    const viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
    const componentRef = viewContainerRef.get(this.dynamicTabs?.findIndex(x => x === tab));
    const activeTab = this.dynamicTabs.filter(x => x.active == true);
    this.selectTab(tab);
    //read ngcontext of current tab item to differentiate between multiple instances. 
    const context = (componentRef as any)?.rootNodes[0].getElementsByClassName('tabChildComponent')[0].children[0].__ngContext__;
    this.tabService.tabClosed(context);
    if (activeTab?.length && activeTab[0] != tab)
      this.selectTab(activeTab[0]);
  }

  closeTab(tab: TabComponent) {
    for (let i = 0; i < this.dynamicTabs.length; i++) {
      if (this.dynamicTabs[i] === tab) {
        this.dynamicTabs.splice(i, 1);
        let viewContainerRef = this.dynamicTabPlaceholder.viewContainer;
        viewContainerRef.remove(i);
        this.selectTab(this.tabs.first);
        this.dataPersistenceService.updateTabInserted(this.dynamicTabs);
        break;
      }
    }
  }

  closeActiveTab() {
    const activeTabs = this.dynamicTabs.filter(tab => tab.active);
    if (activeTabs.length > 0) {
      this.closeTab(activeTabs[0]);
      this.dataPersistenceService.updateTabInserted(this.dynamicTabs);
    }
  }


  IsTabExist(data: any, title: string): any {
    for (let i = 0; i < this.dynamicTabs.length; i++) {

      if (this.dynamicTabs[i].dataContext?.serialNumber === data?.serialNumber
        && this.dynamicTabs[i].dataContext?.product === data?.product
        && title !== "Pre-Register" && title !== "Standalone asset") {
        return {
          tabExist: true,
          indexMatch: i
        }
      }
    }

    return {
      tabExist: false,
      indexMatch: -1
    }
  }
  identifyUnsavedTab(tab) {

  }
}
